import { useRef, useState } from "react";
import { Camera, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const ImageUpload = ({ value, onChange }) => {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/uploads", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Foto enviada");
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <div>
      <Label>Foto do produto</Label>
      <div className="mt-1 flex items-center gap-3">
        <button type="button" data-testid="product-image-upload-button" onClick={() => inputRef.current?.click()} disabled={busy}
          className="relative grid h-20 w-20 shrink-0 place-items-center overflow-hidden rounded-xl border border-dashed border-white/20 bg-white/5 text-slate-400 hover:border-primo-500/60 hover:text-primo-400">
          {value ? <img src={value} alt="" className="h-full w-full object-cover" /> : <Camera className="h-6 w-6" />}
          {busy && <span className="absolute inset-0 grid place-items-center bg-black/60"><Loader2 className="h-5 w-5 animate-spin text-primo-400" /></span>}
        </button>
        <div className="min-w-0 flex-1 space-y-2">
          <button type="button" data-testid="product-image-choose-button" onClick={() => inputRef.current?.click()} disabled={busy}
            className="rounded-full bg-primo-500 px-4 py-1.5 text-sm font-bold text-white hover:bg-primo-400 disabled:opacity-60">
            {busy ? "Enviando..." : "Escolher foto"}
          </button>
          <div className="flex items-center gap-2">
            <Input data-testid="product-image-input" placeholder="ou cole um link https://..." value={value || ""} onChange={(e) => onChange(e.target.value)} />
            {value && <button type="button" data-testid="product-image-clear-button" onClick={() => onChange("")} className="text-slate-500 hover:text-red-400"><X className="h-4 w-4" /></button>}
          </div>
        </div>
      </div>
      <input ref={inputRef} type="file" accept="image/*" data-testid="product-image-file-input" onChange={pick} className="hidden" />
    </div>
  );
};
